export default "__VITE_ASSET__C_G22BF___"